import { Component } from '@angular/core';
import { vendorLogin } from './vendor-login.model';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../shared/auth/auth-service';
import { StorageService } from '../shared/auth/storage-service';
import { LoginService } from '../shared/services/login-service';
import { VendorLoginService } from '../shared/services/vendor-login.service';
import { ConfigService } from '../services/config.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-vendor-login',
  templateUrl: './vendor-login.component.html',
  styleUrls: ['./vendor-login.component.scss']
})
export class VendorLoginComponent {
  login: vendorLogin = new vendorLogin();
  show_button: Boolean = false;
  show_eye: Boolean = false;
  constructor(
    private toastr: ToastrService,
    private vendorLogInServices: VendorLoginService,
    private router: Router,
    private authService: AuthService,
   private configService: ConfigService, 
    private http: HttpClient,
    private storageService: StorageService
  ) {
    if (this.authService.isLoggedIn()) {
      this.router.navigateByUrl('/vendor/dashboard')
    }
  }

  showPassword() {
    this.show_button = !this.show_button;
    this.show_eye = !this.show_eye;
  }

loginUser() {
  this.vendorLogInServices.userLogin(this.login).subscribe((res: any) => {
    if (res && res.body && res.status == 200) {
      const token = res.body.response.token;
      this.authService.setToken(token);
      this.authService.setAuthTokenInCookie(token);
      this.storageService.saveUser(res.body.response);
      this.toastr.success(res.body.message);
      
      const vendorApprovalStatus = res.body.response?.vendorApprovalStatus;
      const vendorId = res.body.response?.vendor_id || res.body.response?.id;
      
      // 🔍 DEBUG - Check actual value
      console.log('========================================');
      console.log('🔍 Vendor Approval Status:', vendorApprovalStatus);
      console.log('🔍 Status Type:', typeof vendorApprovalStatus);
      console.log('🔍 Status Length:', vendorApprovalStatus?.length);
      console.log('🔍 Is "Approved"?', vendorApprovalStatus === 'Approved');
      console.log('🔍 Is "approved"?', vendorApprovalStatus?.toLowerCase() === 'approved');
      console.log('========================================');
      
      // ✅ Use case-insensitive comparison
      const isApproved = vendorApprovalStatus?.toLowerCase()?.trim() === 'approved';
      
      if (isApproved) {
        console.log('✅ APPROVED - Calling API');
        this.fetchVendorModules(); // API call yahan se ho rahi hai
        this.router.navigateByUrl('/vendor/dashboard');
      } else {
        console.log('❌ NOT APPROVED - NO API CALL');
        console.log('📌 Redirecting to contact details');
        // ❌ API call nahi hogi
        this.router.navigate(['/admin/vendor/contact-details'], { 
          queryParams: { 
            vendor_id: vendorId,
            vendor: vendorId 
          } 
        });
      }
    }
  }, (err: any) => {
    if (err.error && err.error.error) {
      this.toastr.error(err.error.error);
    } else {
      this.toastr.error(err.error.message);
    }
    console.error('Login error:', err);
  });
}

// ✅ Yeh method SIRF Approved vendors ke liye call hoga


// Method to fetch vendor modules using ConfigService
private fetchVendorModules() {
  // ✅ Double-check before making API call
  const user = this.storageService.getUser();
  const status = user?.vendorApprovalStatus?.toLowerCase()?.trim();
  
  if (status !== 'approved') {
    console.warn('⚠️ Vendor not approved, skipping API call');
    return; // ❌ API call nahi hogi
  }
  
  console.log('🔄 Fetching vendor modules (Approved vendor)...');
  const modulesUrl = this.configService.navigationVendorMastersUrl;
  
  this.http.get(modulesUrl).subscribe({
    next: (response: any) => {
      if (response && response.code === 200) {
        this.storageService.setVendorModules(response.data);
        console.log('✅ Vendor modules fetched successfully');
      }
    },
    error: (error) => {
      console.error('❌ Error fetching vendor modules:', error);
    }
  });
}
  loginAdmin() {
    this.router.navigateByUrl('/login')
  }
}
